/*
 * @Author: your name
 * @Date: 2021-01-13 20:58:13
 * @LastEditTime: 2021-09-28 11:32:22
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\carInfo\api\index.js
 */
export const api = {
  vehicle: {
    getVehicleList: '/vas/vehicle/queryVehicleList.json', // 获取车辆列表  
    addVehicle: '/vas/vehicle/addVehicle.json', // 员工车辆新增
    importVehicle: '/vas/vehicle/importVehicle.json',//员工导入车辆
    deleteVechicle: '/vas/vehicle/deleteVehicle.json',//员工删除车辆
    download: '/common/file/downLoadTemplateFile.json?templateFileName=importVehicleTemplate.xlsx',//下载导入模板
    queryVisitorVehicleType: ' /vas/vehicle/queryVisitorVehicleTypeList.json',//查询访客车辆分类组
    updateVisitorVehicleType: '/vas/vehicle/updateVisitorVehicleType.json',//修改访客车辆类型信息
    addVisitorVehicleType: ' /vas/vehicle/addVisitorVehicleType.json',//新增访客车辆类型信息
    deleteVisitorVehicleType: '/vas/vehicle/deleteVisitorVehicleType.json',//删除访客车辆类型信息
    updateVehicleVisitorVehicleType: '/vas/vehicle/updateVehicleVisitorVehicleType.json',//挪入挪出车辆类型  
  },
  person: {
    getPersonList: '/vas/personnel/queryPersonListApi.json',//获取员工列表
  }
}